export const refreshPage = () => {
  window.location.reload();
};
